/**
 * 認証ヘッダの共通部分を作って返す
 * @param apiKey API認証キー
 * @param authValue API認証シグネチャ
 * @returns 認証ヘッダ
 */
export const getAuthHeaders = (apiKey: string, authValue: string) => {
	return { "X-Auth-Key": apiKey, "X-Auth-Signature": authValue };
};
